import gql from 'graphql-tag';

import { PLEX_OVERVIEW_FRAGMENT } from './plexOverview';

export const FULL_PLEX_FRAGMENT = gql`
  fragment fullPlex on Plex {
    id
    name
    color
    description
    channels {
      id
      type
      name
      externalId
    }
    googleCalendars {
      id
      googleCalendarId
      description
      summary
    }
    settings {
      members {
        user {
          __typename
          ... on PlexRegisteredUser {
            id
            email
            name
            picture
          }
          ... on PlexInvitedUser {
            email
          }
        }
        role
      }
    }
    defaultBoardId
    deleted

    ...plexOverview
  }

  ${PLEX_OVERVIEW_FRAGMENT}
`;
